import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskErrorDetailComponent } from './task-error-detail.component';
import { CoreModule } from '@dm/core';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
    ],
    declarations: [TaskErrorDetailComponent],
    exports: [TaskErrorDetailComponent],
})
export class TaskErrorDetailModule { }
